import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type collectionChangePlanPopupQuery,
} from './__generated__/collectionChangePlanPopupQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	collectionEntitlementId: string;
	hamsProductKey: string;
	shouldShowPspLink: boolean;
};

export const entryPoint: EntryPoint<
	EntryPointComponent<
		{
			collectionChangePlanPopupQuery: collectionChangePlanPopupQuery;
		},
		Record<string, never>,
		{
			onClose: (extraInformation?: unknown) => void;
		},
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-collection-change-plan-popup" */ './collection-change-plan-popup'
			),
		{
			moduleId: 'edition-awareness-collection-change-plan-popup',
		},
	),
	getPreloadProps: ({
		cloudId,
		collectionEntitlementId,
		hamsProductKey,
		shouldShowPspLink,
	}: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			collectionChangePlanPopupQuery: {
				parameters,
				variables: {
					cloudId,
					collectionEntitlementId,
					hamsProductKey,
					shouldShowPspLink,
				},
			},
		},
	}),
});
